export default __webpack_public_path__ + "static/media/vjcet1.c0a70018.png";